var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("选择标签"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      width: 1000,
      closable: false,
      "cancel-button-props": {
        style: {
          display: "none"
        }
      }
    },
    on: {
      ok: _vm.handleSure
    }
  }, [_c("div", {
    staticClass: "box"
  }, [_c("div", {
    staticClass: "topBox"
  }, [_c("div", {
    staticClass: "leftBox"
  }, [_c("a-input", {
    on: {
      change: _vm.tagChange
    },
    model: {
      value: _vm.tagName,
      callback: function ($$v) {
        _vm.tagName = $$v;
      },
      expression: "tagName"
    }
  }), _c("div", {
    staticClass: "itemBox"
  }, _vm._l(_vm.tagListData, function (item, index) {
    return _c("div", {
      key: index,
      on: {
        click: function ($event) {
          ;
          _vm.tagLeftIndex = index, _vm.tagValue = "";
        }
      }
    }, [_c("div", {
      style: index == _vm.tagLeftIndex ? "color:#1890ff" : ""
    }, [_vm._v(_vm._s(item.fieldKey))]), index == _vm.tagLeftIndex ? _c("a-icon", {
      style: {
        color: "#1890ff"
      },
      attrs: {
        type: "right"
      }
    }) : _c("a-icon", {
      attrs: {
        type: "right"
      }
    })], 1);
  }), 0)], 1), _c("div", {
    staticClass: "rightBox"
  }, [_c("a-input", {
    on: {
      change: _vm.tagValueChange
    },
    model: {
      value: _vm.tagValue,
      callback: function ($$v) {
        _vm.tagValue = $$v;
      },
      expression: "tagValue"
    }
  }), _vm.tagListData.length != 0 && !_vm.tagValue ? _c("div", {
    staticClass: "itemBox"
  }, _vm._l(_vm.tagListData[_vm.tagLeftIndex].children, function (item, index) {
    return _c("div", {
      key: index,
      on: {
        click: function ($event) {
          return _vm.choiceItemFun(item);
        }
      }
    }, [_c("div", {
      style: item.choice ? "color:#1890ff" : ""
    }, [_vm._v(_vm._s(item.fieldFrontValue || item.fieldValue))]), item.choice ? _c("a-icon", {
      style: {
        color: "#1890ff"
      },
      attrs: {
        type: "check"
      }
    }) : _vm._e()], 1);
  }), 0) : _vm._e(), _vm.tagValue ? _c("div", {
    staticClass: "itemBox"
  }, _vm._l(_vm.tagValueList, function (item, index) {
    return _c("div", {
      key: index,
      on: {
        click: function ($event) {
          return _vm.choiceItemFun(item);
        }
      }
    }, [_c("div", {
      style: item.choice ? "color:#1890ff" : ""
    }, [_vm._v(_vm._s(item.fieldFrontValue || item.fieldValue))]), item.choice ? _c("a-icon", {
      style: {
        color: "#1890ff"
      },
      attrs: {
        type: "check"
      }
    }) : _vm._e()], 1);
  }), 0) : _vm._e()], 1)]), _c("div", {
    staticClass: "bottomBox"
  }, [_c("div", {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t("已选择")) + ":")]), _vm._l(_vm.tagList2, function (item, index) {
    return _c("span", {
      key: index,
      staticClass: "contBox"
    }, [index != 0 ? _c("span", {
      staticStyle: {
        "margin-right": "8px"
      }
    }, [_vm._v("、")]) : _vm._e(), _vm._l(item, function (item2, index2) {
      return _c("span", {
        key: index2,
        staticClass: "flex"
      }, [index2 != 0 ? _c("span", {
        staticStyle: {
          "margin-right": "8px"
        }
      }, [_vm._v(_vm._s(_vm.$t("或")))]) : _vm._e(), item2.choice ? _c("a-tag", {
        key: item2.fieldKey + item2.fieldValue,
        attrs: {
          color: "blue",
          closable: ""
        },
        on: {
          close: () => _vm.handleClose(item2)
        }
      }, [_vm._v(" " + _vm._s(item2.fieldKey) + ":" + _vm._s(item2.fieldFrontValue || item2.fieldValue) + " ")]) : _vm._e()], 1);
    })], 2);
  }), _c("span", {
    staticClass: "contBox"
  }, [_vm.tagList2.length != 0 && _vm.arr.length != 0 ? _c("span", {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v("、")]) : _vm._e(), _vm._l(_vm.arr, function (item2, index2) {
    return _c("span", {
      key: index2,
      staticClass: "flex"
    }, [index2 != 0 ? _c("span", {
      staticStyle: {
        "margin-right": "8px"
      }
    }, [_vm._v(_vm._s(_vm.$t("或")))]) : _vm._e(), item2.choice ? _c("a-tag", {
      key: item2.fieldKey + item2.fieldValue,
      attrs: {
        color: "blue",
        closable: ""
      },
      on: {
        close: function ($event) {
          return _vm.handleClose(item2);
        }
      }
    }, [_vm._v(" " + _vm._s(item2.fieldKey) + ":" + _vm._s(item2.fieldFrontValue || item2.fieldValue) + " ")]) : _vm._e()], 1);
  })], 2)], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };